import { isImageLikeFile, isPdfFile } from "../../../../common/helpers/file-upload";

type ImageModalProps = {
  image?: string;
  onClose: () => void;
  title?: string;
  fileType?: "image" | "pdf" | "file";
};

function ImageModal({ image, onClose, title, fileType }: ImageModalProps) {
  const isPdf = fileType ? fileType === "pdf" : isPdfFile(image);
  const isImage = fileType ? fileType === "image" : isImageLikeFile(image);

  return (
    <div className="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                {title && <h3 className="mb-4 text-lg font-semibold text-gray-900">{title}</h3>}
                {isImage && <img src={image} className="mx-auto max-h-[75vh] object-contain" alt="Arquivo" />}
                {isPdf && (
                  <iframe
                    src={image}
                    title={title || "PDF"}
                    className="h-[75vh] w-full min-w-[320px]"
                  />
                )}
                {!isImage && !isPdf && (
                  <div className="flex min-h-[240px] min-w-[320px] items-center justify-center">
                    <a
                      href={image}
                      target="_blank"
                      rel="noreferrer"
                      className="rounded-md bg-redPrimary px-4 py-2 text-white"
                    >
                      Abrir arquivo
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button type="button" className="bg-redPrimary mt-3 w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm" onClick={onClose}>
              Fechar
            </button>

          </div>
        </div>
      </div>

    </div>
  );
}

export default ImageModal;
